import { connect } from "react-redux";
import Layout from "common/Layout";
import {
  getComboCuaHang,
  chuyenCuaHang,
  thongTinCuaHangHienTai,
} from "actions/QuanLyCuaHang";
import { getCurrentUser } from "actions/User";
import { getMenu, getBadgeMenu } from "actions/Menu";
import { getListThongBao } from "actions/ThongBao";

const mapStateToProps = (state) => ({
  quanlycuahang: state.quanlycuahang,
  user: state.user,
  menu: state.menu,
  thongbao: state.thongbao,
});

const mapDispatchToProps = (dispatch) => ({
  getComboCuaHang: () => dispatch(getComboCuaHang()),
  chuyenCuaHang: (dataPost) => dispatch(chuyenCuaHang(dataPost)),
  thongTinCuaHangHienTai: () => dispatch(thongTinCuaHangHienTai()),
  getCurrentUser: () => dispatch(getCurrentUser()),
  getMenu: () => dispatch(getMenu()),
  getBadgeMenu: () => dispatch(getBadgeMenu()),
  getListThongBao: () => dispatch(getListThongBao()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
